import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { colors } from '@resurs/midas'
import { Button } from '@resurs/midas-react'
import { getText } from '../../../../internal/TextLabels'
import {
  getApplicationOrPayment,
  getPendingApplicationOnAccount,
  printAgreement,
} from '../../../../store/actions/pay-apply-actions'
import { actOnData, recentlyCreated } from '../../../../util/helpers'
import isInternetExplorer from '../../../../util/internetExplorerHelper'
import PrintModalUI from '../shared/PrintModalUI'
import SignPendingApplication from './SignPendingApplication'

class PendingAccountApplication extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      pendingApplication: null,
      agreementUrl: null,
      fetchingAgreement: false,
      showAgreementModal: false,
      showElectronicSigning: false,
      isSkippedSigning: false,
    }
  }

  componentDidMount() {
    this.loadPendingApplications()
  }

  getPendingApplicationAgreementUrl = async () => {
    const { pendingApplication } = this.state
    this.setState({
      fetchingAgreement: true,
    })
    const agreementUrl = await this.props
      .printAgreement(pendingApplication.id, pendingApplication.type)
      .catch(() => null)
    this.setState({
      agreementUrl,
      fetchingAgreement: false,
    })
    return agreementUrl
  }

  loadPendingApplications() {
    this.props
      .getPendingApplicationOnAccount(this.props.card)
      .then(async pendingApplication => {
        if (pendingApplication) {
          const application = await this.props.getApplicationOrPayment(
            pendingApplication,
          )
          if (application.signing) {
            if (application.signing.physicalSigning) {
              const signingTypes =
                application.signing.availableSigningTypes || []
              this.setState({
                showElectronicSigning:
                  signingTypes.includes('ELECTRONIC') &&
                  recentlyCreated(application.created),
              })
            }
            this.setState({
              isSkippedSigning: !!application.signing.skippedSigning,
            })
          }
        }
        return pendingApplication
      })
      .then(pendingApplication => {
        this.setState({ pendingApplication })
      })
  }

  render() {
    const {
      pendingApplication,
      fetchingAgreement,
      agreementUrl,
      showAgreementModal,
      showElectronicSigning,
      isSkippedSigning,
    } = this.state

    return (
      <>
        {pendingApplication ? (
          <div>
            <p style={{ width: '75%', color: colors.red, margin: 0 }}>
              {isSkippedSigning
                ? getText('payApply.paymentMethod.skippedSigningMessage')
                : getText('payApply.paymentMethod.agreementMissing')}
            </p>
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '15px',
              }}
            >
              {!isSkippedSigning ? (
                <Button
                  onClick={async () => {
                    let url = agreementUrl
                    if (!url) {
                      url = await this.getPendingApplicationAgreementUrl()
                    }
                    if (isInternetExplorer()) {
                      window.open(url, '_blank')
                    } else {
                      this.setState({
                        showAgreementModal: true,
                      })
                    }
                  }}
                  loading={!!fetchingAgreement}
                >
                  {getText('payApply.sign.printPaperSign')}
                </Button>
              ) : null}
              {showElectronicSigning ? (
                <SignPendingApplication
                  buttonDivStyle={{ marginLeft: '10px' }}
                  hideText
                  card={this.props.card}
                  data={this.props.payApplyData}
                  onReload={() => this.loadPendingApplications()}
                />
              ) : null}
            </div>
          </div>
        ) : null}
        {actOnData(agreementUrl, url => (
          <PrintModalUI
            title={getText('payApply.sign.printPaperSign')}
            show={!!showAgreementModal}
            url={url}
            onClose={() => {
              this.setState({ showAgreementModal: false })
            }}
            closeText={getText('default.close')}
          />
        ))}
      </>
    )
  }
}

PendingAccountApplication.propTypes = {
  card: PropTypes.shape({
    accountNumber: PropTypes.string.isRequired,
    applicant: PropTypes.string.isRequired,
  }).isRequired,
  payApplyData: PropTypes.object.isRequired,
  getPendingApplicationOnAccount: PropTypes.func.isRequired,
  printAgreement: PropTypes.func.isRequired,
  getApplicationOrPayment: PropTypes.func.isRequired,
}

export default connect(null, dispatch => ({
  getPendingApplicationOnAccount: card =>
    dispatch(getPendingApplicationOnAccount(card)),
  getApplicationOrPayment: applicationId =>
    dispatch(getApplicationOrPayment(applicationId)),
  printAgreement: (id, type) => dispatch(printAgreement({ id, type })),
}))(PendingAccountApplication)
